import { OpportunityWorkflow_Transitions } from "lib/generated/app-service-gql/graphql";

export type StageOption = {
  label: string;
  value: string;
  color: string;
  iconColor: string;
  iconName: string;
  transitionGroup: string;
};

export type GroupedStageOptions = {
  label: string;
  value: string;
  options: StageOption[];
};

export function processTransitions(
  transitions: OpportunityWorkflow_Transitions[],
): GroupedStageOptions[] {
  return transitions.reduce<GroupedStageOptions[]>((acc, transition) => {
    const groupIndex = acc.findIndex((group) => group.value === transition.group);
    const option = {
      label: transition.stage.name,
      value: transition.stage.id,
      color: transition.stage.color,
      iconColor: transition.stage.iconColor,
      iconName: transition.stage.iconName,
      transitionGroup: transition.group,
    };
    if (groupIndex > -1) {
      acc[groupIndex].options.push(option);
    } else {
      acc.push({
        // Pre-engagement is a special case
        label: transition.group.replace("Pre_E", "Pre-e").replace("_", " "),
        value: transition.group,
        options: [option],
      });
    }
    return acc;
  }, []);
}
